/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { FC, useContext } from 'react';
import { SxProps, Theme, styled } from '@mui/material';
import { useSingleSettings } from '@/data/Settings';
import { useCart } from '@/data/Content/Cart';

type Props = {
	inAddressForm?: boolean;
	inDrawer?: any;
};

const StyledExtendedZone = styled('div')`
	font-size: 11px;
	font-weight: 500;
	font-family: Open Sans, 'Helvetica Neue', Arial, sans-serif;
	margin: 3px 0 0;
	width: 100%;
	box-sizing: border-box;
`;

export const StyledExtendedZoneSX: SxProps<Theme> = {
	padding: '0 20px 20px',
	marginTop: '-12px',
};

export const AlertExtendedZone: FC<Props> = ({ inAddressForm, inDrawer }) => {
	// const labels = useLocalization('Shipping').Labels;
	const { settings } = useSingleSettings();
	const { data: cart } = useCart();
	const minAmtExtendedZoneEG = Number(settings?.userData['com.min.amount.extended.zone.eg']);
	const showComponent = inAddressForm ? true : showExtendedZoneShippingInSummary();

	function showExtendedZoneShippingInSummary() {
		const montoMinimoEG = Number(settings?.userData['com.monto.minimo.eg']);
		const totalShippingCharge = Number(cart?.totalShippingCharge);
		const grandTotal = Number(cart?.grandTotal);
		let isExtendedZoneShipping = false;

		if (totalShippingCharge > 0) {
			const grandTotalEffective = grandTotal - totalShippingCharge;

			if (grandTotalEffective > montoMinimoEG) {
				isExtendedZoneShipping = grandTotalEffective < minAmtExtendedZoneEG;
			}
		}
		return isExtendedZoneShipping;
	}

	return showComponent ? (
		<StyledExtendedZone
			id="extended-zone-shipping"
			style={{ color: `${inAddressForm ? '#d07800' : '#2C2C2C'}` }}
			sx={inDrawer ? StyledExtendedZoneSX : null}
		>
			{'ⓘ Su ubicación no califica para envío gratis. Compra mínima '}
			{new Intl.NumberFormat('es-MX', {
				style: 'currency',
				currency: 'MXN',
				minimumSignificantDigits: 1,
			}).format(minAmtExtendedZoneEG)}
			{' o cambio de código postal para envío gratis.'}
		</StyledExtendedZone>
	) : null;
};
